<template>
  <div>
    <div
      v-if="!hideHint"
      class="mb-1"
    >
      您好，此件包裹已入庫，請於下方輸入框輸入包裹運單號查詢，謝謝
    </div>
    <v-layout align-center>
      <v-text-field
        v-model.trim="searchKey"
        :loading="searchLoading"
        label="一鍵查詢包裹"
        solo
        hide-details
        type="searth"
        class="mt-0 pt-0"
        @keyup.enter="searchHandle"
      />
      <v-btn
        :loading="searchLoading"
        fab
        small
        color="info"
        class="ml-2"
        @click="searchHandle"
      >
        <v-icon>search</v-icon>
      </v-btn>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: {
    hideHint: Boolean,
  },
  data () {
    return {
      searchLoading: false,
      searchKey: '',
    }
  },
  methods: {
    async searchHandle () {
      if (!this.searchKey || this.searchLoading) return
      await this.$nextTick()
      try {
        this.searchLoading = true
        const s = this.searchKey
        const res = await this.$store.dispatch('search/search', {
          mixed: s
        })
        if (res.data.name === 'parcel-view') {
          this.$router.push({ name: 'Parcel', query: { searchKey: s } })
        } else if (res.data.name === 'jyorder-view' && res.data.model && res.data.model.oid) {
          this.$store.commit('search/setOldSearchKey', s)
          this.$store.commit('order/setShowOrderDialogData', { oid: res.data.model.oid })
        } else if (res.data.name === 'jyorder-index' && res.data.list.length) {
          if (res.data.list.length === 1) {
            this.$store.commit('search/setOldSearchKey', s)
            this.$store.commit('order/setShowOrderDialogData', { oid: res.data.list[0].oid })
          } else {
            this.$router.push({ name: 'Order', query: { searchKey: s }, params: { list: res.data.list } })
          }
        } else {
          this.$snackbar('查無此單號，請確認輸入是否正確後再次搜尋')
        }
      } finally {
        this.searchLoading = false
      }
    },
  }
}
</script>
